<template>
  <div v-if="retribution" class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <StackedField :label="t('seller_amount')" :value="formatPrice(retribution.sellerAmount)" />
      <StackedField :label="t('manager_amount')" :value="formatPrice(retribution.managerAmount)" />
    </div>

    <div class="mt-6 pt-4 border-t border-gray-100">
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-600">{{ t("total") }}</span>
        <span class="text-lg font-semibold text-gray-900">{{ formatPrice(totalAmount) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  name: "RetributionDetails",

  components: { StackedField },

  props: {
    retribution: {
      type: Object,
      default: null,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    totalAmount() {
      const sellerAmount = Number(this.retribution.sellerAmount) || 0;
      const managerAmount = Number(this.retribution.managerAmount) || 0;
      return sellerAmount + managerAmount;
    },
  },

  methods: { formatPrice },
};
</script>

<i18n src="./RetributionDetails.i18n.json"></i18n>
